import { TAKTILE_CHART_CONFIG } from "src/analytics/metrics/VisualizeMetrics/liveAnalyticsDomains";

export const CASE_BAR_WIDTH = 12;

export const CASE_TAKTILE_CHART_CONFIG = {
  ...TAKTILE_CHART_CONFIG,
  bar: {
    ...TAKTILE_CHART_CONFIG.bar,
    width: CASE_BAR_WIDTH,
  },
};
